module.exports = __webpack_public_path__ + "static/media/sixPin.d11040f6.svg";